import {useState,  useEffect} from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import {delApiSitesSiteEdgeId, getApiSitesSite} from '../../common/fetch_api/site'
import {strArraySortDesc} from '../../common/app_common'
import {BsPencilSquare, BsTrash, BsExclamationCircle} from 'react-icons/bs';
import Button from 'react-bootstrap/Button';
import * as ModalPage from './modals';
import {DecideWindow} from '../../common/modal_common.js';

export const DetailEdgeCanvas = ({siteInfo, edgeType, show, handleClose, updateParents}) => {
    
    const [edgeInfoId, setEdgeInfoId] = useState('');

    const [modalEdgeInfo, setModalEdgeInfo] = useState(false);
    const closeOffcanvasEdgeInfo = () => setModalEdgeInfo(false);
    const showModalEdgeInfo = (edgeId) => {
        setEdgeInfoId(edgeId);
        setModalEdgeInfo(true);
    }

    const [modalEdgeEdit, setModalEdgeEdit] = useState(false);
    const closeOffcanvasEdgeEdit = () => setModalEdgeEdit(false);
    const showModalEdgeEdit = (edgeId) => {
        setEdgeInfoId(edgeId);
        setModalEdgeEdit(true);
    }
    
    const [modalDecide, setModalDecide] = useState(false);
    const closeOffcanvasDecide = () => setModalDecide(false);
    const showModalDecide = (edgeData) => {
        setEdgeInfoId(edgeData);
        setModalDecide(true);
    }
    
    const [canvasHtml, setCanvasHtml] = useState(null);
    const [update, setUpdate] = useState(false);

    function runUpdate()
    {
        setUpdate(!update);
        updateParents();
    }

    function onClickDecide(is)
    {
        if(is)
        {
            Promise.resolve( delApiSitesSiteEdgeId(siteInfo.name, edgeInfoId.id) )
            .then( done => {
                updateParents();
                setUpdate(!update);
            });
        }
    }

    useEffect(() => {
        Promise.resolve( getApiSitesSite(siteInfo.name) )
        .then( siteInfo => {
            let edgeInfo = [];

            if(edgeType === 'm-agent')
            {
                edgeInfo = siteInfo.edgeList.filter((x) => {return x.type === 'm-agent'});
            }
            else if(edgeType === 's-agent')
            {
                edgeInfo = siteInfo.edgeList.filter((x) => {return x.type === 's-agent'});
            }
            else if(edgeType === 'r-agent')
            {
                edgeInfo = siteInfo.edgeList.filter((x) => {return x.type === 'r-agent'});
            }
            else if(edgeType === 'rm')
            {
                edgeInfo = siteInfo.edgeList.filter((x) => {return x.type === 'rm'});
            }

            edgeInfo.sort((a, b) => strArraySortDesc(a.name.toLowerCase(), b.name.toLowerCase()));

            setCanvasHtml(edgeInfo.map( (edge, index) =>
                <tr key={edge.name}>
                    <td>
                        <div className={`edge-box edge-default`}>{edge.type==='m-agent'?'M':edge.type==='s-agent'?'S':edge.type==='r-agent'?'R':'T'}</div>
                    </td>
                    <td>
                        <div className="label-edge">{edge.tag !== '' ? edge.tag : '-'}</div>
                    </td>
                    <td>
                        <div className="label-edge">{edge.name}</div>
                    </td>
                    <td>
                        <Button variant="primary" className="btn btn-icon" onClick={() => {showModalEdgeEdit(edge.id)}}><BsPencilSquare/></Button>
                    </td>
                    <td>
                        <Button variant="secondary" className="btn btn-icon" onClick={() => {showModalEdgeInfo(edge.id)}}><BsExclamationCircle/></Button>
                    </td>
                    <td>
                        <Button variant="danger" className="btn btn-icon" onClick={() => {showModalDecide(edge)}}><BsTrash/></Button>
                    </td>
                </tr>
            ));
        });
    }, [show, edgeType, update]);

    const SetDecideBody = () => {
        return(
            <div className='text-center'>
                <p>Are you sure you want to delete this Edge?</p>
                <p>The deleted Edges will be moved to Pending.</p>
            </div>
        );
    }

    const closeOffcanvas = () => {
        handleClose();
        show = false;
    }

    return (
        <>
            <Offcanvas show={show} onHide={closeOffcanvas} placement="end">
                <Offcanvas.Header>
                    <Offcanvas.Title>
                        <span className='edge-detail-title'>{siteInfo.name}</span>
                    </Offcanvas.Title>
                    <Button variant='close' className="btn-close-white" onClick={closeOffcanvas}></Button>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="edge-details-table">
                        <table className="table table-sm text-center">
                            <tbody>
                                {canvasHtml}
                            </tbody>
                        </table>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            {modalEdgeEdit&&<ModalPage.EdgeEditModal siteInfo={siteInfo} edgeId={edgeInfoId} show={modalEdgeEdit} handleClose={closeOffcanvasEdgeEdit} update={runUpdate}></ModalPage.EdgeEditModal>}
            {modalEdgeInfo&&<ModalPage.EdgeInfoModal edgeId={edgeInfoId} show={modalEdgeInfo} handleClose={closeOffcanvasEdgeInfo}></ModalPage.EdgeInfoModal>}
            {modalDecide&&<DecideWindow result={onClickDecide} show={modalDecide} handleClose={closeOffcanvasDecide} body={<SetDecideBody/>} okButtonTxt={'Remove'}></DecideWindow>}
        </>
    )
}